import React from 'react';

// @deprecated
export const LoadingLines: React.FunctionComponent = () => (
  <div className="gik-loading-lines">
    <div className="gik-loading-lines__mask gik-loading-lines__mask__vertical__1"></div>
    <div className="gik-loading-lines__mask gik-loading-lines__mask__vertical__2"></div>
    <div className="gik-loading-lines__mask gik-loading-lines__mask__vertical__3"></div>
    <div className="gik-loading-lines__mask gik-loading-lines__mask__horizontal__1"></div>
    <div className="gik-loading-lines__mask gik-loading-lines__mask__horizontal__2"></div>
    <div className="gik-loading-lines__mask gik-loading-lines__mask__horizontal__3"></div>
  </div>
);
